"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitPanel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var styles_1 = require("../../styles");
var base_1 = require("../base");
var RiArrowUpDownLine_1 = require("@react-icons/all-files/ri/RiArrowUpDownLine");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var react_1 = require("react");
var lib_1 = require("../../hooks/lib");
var hooks_1 = require("./hooks");
var utils_1 = require("../../utils");
var context_1 = require("../../context/context");
var actions_1 = require("../../context/actions");
var LimitSwitch_1 = require("./LimitSwitch");
var Components_1 = require("../Components");
var DefaultInput = function (_a) {
    var isLoading = _a.isLoading, onChange = _a.onChange, value = _a.value;
    return (0, jsx_runtime_1.jsx)(base_1.NumericInput, { disabled: isLoading, onChange: onChange, value: value });
};
var DefaultTokenSelect = function (props) {
    var _a, _b;
    return (0, jsx_runtime_1.jsx)(StyledTokenSelect, { className: "twap-limit-panel-token-select", logo: (_a = props.token) === null || _a === void 0 ? void 0 : _a.logoUrl, symbol: (_b = props.token) === null || _b === void 0 ? void 0 : _b.symbol, onClick: props.onClick });
};
var StyledTokenSelect = (0, styled_components_1.styled)(base_1.TokenDisplay)({
    fontSize: 14,
    cursor: "pointer",
    ".twap-token-logo": {
        width: "20px",
        height: "20px",
    },
});
var DefaultTitle = function (props) {
    var _a, _b;
    return ((0, jsx_runtime_1.jsxs)(StyledDefaultTitle, __assign({ className: "twap-limit-panel-title" }, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: props.textLeft }), (0, jsx_runtime_1.jsx)(base_1.TokenDisplay, { symbol: (_a = props.token) === null || _a === void 0 ? void 0 : _a.symbol, logo: (_b = props.token) === null || _b === void 0 ? void 0 : _b.logoUrl, onClick: props.onTokenClick }), (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: props.textRight })] })));
};
var StyledDefaultTitle = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    width: "auto",
    flex: 1,
    gap: 5,
    justifyContent: "flex-start",
    fontSize: 14,
    ".twap-token-display": {
        cursor: "pointer",
    },
    ".twap-token-logo": {
        width: "20px",
        height: "20px",
    },
});
var DefaultZeroButton = function (_a) {
    var onClick = _a.onClick, text = _a.text;
    return (0, jsx_runtime_1.jsx)("button", __assign({ onClick: onClick }, { children: text }));
};
var DefaultPercentButton = function (_a) {
    var text = _a.text, onClick = _a.onClick, selected = _a.selected;
    return (0, jsx_runtime_1.jsx)("button", __assign({ onClick: onClick }, { children: text }));
};
var defaultPercent = [1, 5, 10];
var Context = (0, react_1.createContext)({});
var useLimitPanelContext = function () { return (0, react_1.useContext)(Context); };
var LimitPanel = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    var hide = (0, lib_1.useShouldWrapOrUnwrapOnly)();
    if (hide)
        return null;
    return (0, jsx_runtime_1.jsx)(StyledContainer, __assign({ className: className }, { children: children }));
};
exports.LimitPanel = LimitPanel;
var StyledContainer = (0, styled_components_1.styled)("div")({
    width: "100%",
});
function Main(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, onSrcSelect = _a.onSrcSelect, onDstSelect = _a.onDstSelect, Components = _a.Components, styles = _a.styles;
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    if (isMarketOrder) {
        return (0, jsx_runtime_1.jsx)(Components_1.MarketPriceWarning, {});
    }
    return ((0, jsx_runtime_1.jsx)(Context.Provider, __assign({ value: { onSrcSelect: onSrcSelect, onDstSelect: onDstSelect, Components: Components, styles: styles } }, { children: (0, jsx_runtime_1.jsxs)(Container, __assign({ className: "twap-limit-panel ".concat(className) }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ style: { justifyContent: "space-between" } }, { children: [(0, jsx_runtime_1.jsx)(Title, {}), (0, jsx_runtime_1.jsx)(InvertPrice, {})] })), (0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ style: { justifyContent: "space-between" } }, { children: [(0, jsx_runtime_1.jsx)(Input, {}), (0, jsx_runtime_1.jsx)(TokenSelect, {})] })), (0, jsx_runtime_1.jsx)(PercentSelector, {})] })) })));
}
var Input = function () {
    var Components = useLimitPanelContext().Components;
    var _a = (0, context_1.useTwapContext)(), state = _a.state, dstToken = _a.dstToken;
    var isInvertedLimitPrice = state.isInvertedLimitPrice, isCustomLimitPrice = state.isCustomLimitPrice, customLimitPrice = state.customLimitPrice;
    var _b = (0, lib_1.useLimitPrice)(), isLoading = _b.isLoading, priceUi = _b.priceUi;
    var onChange = actions_1.stateActions.useOnLimitChange();
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    var limitPriceUi = (0, react_1.useMemo)(function () {
        if (isCustomLimitPrice) {
            return customLimitPrice;
        }
        var res = priceUi;
        if (isInvertedLimitPrice) {
            res = (0, bignumber_js_1.default)(1)
                .div(res || 0)
                .toString();
        }
        return (0, utils_1.formatDecimals)(res);
    }, [customLimitPrice, isCustomLimitPrice, isInvertedLimitPrice, priceUi, dstToken]);
    var _c = (0, react_1.useState)(""), value = _c[0], setValue = _c[1];
    (0, react_1.useEffect)(function () {
        setValue(limitPriceUi || "");
    }, [limitPriceUi]);
    return ((0, jsx_runtime_1.jsx)(StyledInputContainer, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: { opacity: isMarketOrder ? 0 : 1, pointerEvents: isMarketOrder ? "none" : "all" } }, { children: (Components === null || Components === void 0 ? void 0 : Components.Input) ? ((0, jsx_runtime_1.jsx)(Components.Input, { isLoading: isLoading, onChange: onChange, value: value })) : ((0, jsx_runtime_1.jsx)(DefaultInput, { isLoading: isLoading, onChange: onChange, value: value })) })) }));
};
var StyledInputContainer = (0, styled_components_1.styled)("div")({
    position: "relative",
    flex: 1,
});
var usePercent = function () {
    var inverted = (0, context_1.useTwapContext)().state.isInvertedLimitPrice;
    return (0, react_1.useMemo)(function () {
        if (inverted) {
            return defaultPercent.map(function (it) { return -it; }).map(function (it) { return it.toString(); });
        }
        return defaultPercent.map(function (it) { return it.toString(); });
    }, [inverted]);
};
var PercentSelector = function () {
    var percent = usePercent();
    var styles = useLimitPanelContext().styles;
    var disabled = (0, lib_1.useLimitPrice)().isLoading;
    return ((0, jsx_runtime_1.jsxs)(StyledPercentContainer, __assign({ style: { pointerEvents: disabled ? "none" : "all", gap: (styles === null || styles === void 0 ? void 0 : styles.percentButtonsGap) || 5, opacity: disabled ? 0.8 : 1 } }, { children: [(0, jsx_runtime_1.jsx)(ZeroButton, {}), percent.map(function (it) {
                return (0, jsx_runtime_1.jsx)(PercentButton, { percent: it }, it);
            })] })));
};
var PercentButton = function (_a) {
    var percent = _a.percent;
    var state = (0, context_1.useTwapContext)().state;
    var inverted = state.isInvertedLimitPrice, isMarketOrder = state.isMarketOrder, limitPricePercent = state.limitPricePercent;
    var priceDeltaPercentage = (0, lib_1.useLimitPricePercentDiffFromMarket)();
    var limitPrice = (0, lib_1.useLimitPrice)().price;
    var Components = useLimitPanelContext().Components;
    var onPercentageChange = (0, hooks_1.useOnLimitPercentageClick)();
    var selected = (0, react_1.useMemo)(function () {
        var p = limitPricePercent || priceDeltaPercentage;
        if ((0, bignumber_js_1.default)(limitPrice || 0).isZero()) {
            return false;
        }
        return (0, bignumber_js_1.default)(p || 0).eq(percent);
    }, [limitPricePercent, percent, isMarketOrder, limitPrice, priceDeltaPercentage]);
    var prefix = percent === "0" ? "" : inverted ? "-" : !inverted && "+";
    if (Components === null || Components === void 0 ? void 0 : Components.PercentButton) {
        return (0, jsx_runtime_1.jsx)(Components.PercentButton, { onClick: function () { return onPercentageChange(percent); }, selected: selected, text: "".concat(prefix).concat(Math.abs(Number(percent)), "%") });
    }
    return (0, jsx_runtime_1.jsx)(DefaultPercentButton, { onClick: function () { return onPercentageChange(percent); }, selected: selected, text: "".concat(prefix).concat(Math.abs(Number(percent)), "%") });
};
var ZeroButton = function () {
    var limitPricePercent = (0, context_1.useTwapContext)().state.limitPricePercent;
    var priceDeltaPercentage = (0, lib_1.useLimitPricePercentDiffFromMarket)();
    var onPercentageChange = (0, hooks_1.useOnLimitPercentageClick)();
    var Components = useLimitPanelContext().Components;
    var percent = usePercent();
    var showZero = (0, react_1.useMemo)(function () {
        if ((0, bignumber_js_1.default)(priceDeltaPercentage).isZero()) {
            return false;
        }
        if ((0, bignumber_js_1.default)(limitPricePercent || 0).gt(0)) {
            return false;
        }
        if (limitPricePercent && percent.includes(limitPricePercent)) {
            return false;
        }
        if (priceDeltaPercentage && percent.includes(priceDeltaPercentage)) {
            return false;
        }
        return true;
    }, [priceDeltaPercentage, limitPricePercent, percent]);
    if (showZero) {
        return (Components === null || Components === void 0 ? void 0 : Components.ZeroButton) ? ((0, jsx_runtime_1.jsx)(Components.ZeroButton, { onClick: function () { return onPercentageChange("0"); }, text: "".concat(priceDeltaPercentage, "%") })) : ((0, jsx_runtime_1.jsx)(DefaultZeroButton, { onClick: function () { return onPercentageChange("0"); }, text: "".concat(priceDeltaPercentage, "%") }));
    }
    return (0, jsx_runtime_1.jsx)(PercentButton, { percent: "0" });
};
var TokenSelect = function () {
    var _a = (0, context_1.useTwapContext)(), state = _a.state, srcToken = _a.srcToken, dstToken = _a.dstToken;
    var inverted = state.isInvertedLimitPrice;
    var Components = useLimitPanelContext().Components;
    var token = inverted ? srcToken : dstToken;
    var _b = useLimitPanelContext(), onDstSelect = _b.onDstSelect, onSrcSelect = _b.onSrcSelect;
    if (Components === null || Components === void 0 ? void 0 : Components.TokenSelect) {
        return (0, jsx_runtime_1.jsx)(Components.TokenSelect, { isSrcToken: !!inverted, token: token, onClick: inverted ? onSrcSelect : onDstSelect });
    }
    return (0, jsx_runtime_1.jsx)(DefaultTokenSelect, { isSrcToken: !!inverted, token: token, onClick: inverted ? onSrcSelect : onDstSelect });
};
var InvertPrice = function () {
    var onInvert = actions_1.stateActions.useInvertLimit();
    return ((0, jsx_runtime_1.jsx)(StyledInvertprice, __assign({ onClick: onInvert, className: "twap-limit-panel-invert-button" }, { children: (0, jsx_runtime_1.jsx)(base_1.Icon, { icon: (0, jsx_runtime_1.jsx)(RiArrowUpDownLine_1.RiArrowUpDownLine, { size: "16px" }) }) })));
};
var Title = function () {
    var _a = useLimitPanelContext(), onDstSelect = _a.onDstSelect, onSrcSelect = _a.onSrcSelect;
    var Components = useLimitPanelContext().Components;
    var _b = (0, context_1.useTwapContext)(), t = _b.translations, state = _b.state, srcToken = _b.srcToken, dstToken = _b.dstToken;
    var inverted = state.isInvertedLimitPrice;
    var token = inverted ? dstToken : srcToken;
    if (Components === null || Components === void 0 ? void 0 : Components.Title) {
        return (0, jsx_runtime_1.jsx)(Components.Title, { isSrcToken: !inverted, textLeft: t.swapOne, textRight: t.isWorth, token: token, onTokenClick: inverted ? onDstSelect : onSrcSelect });
    }
    return (0, jsx_runtime_1.jsx)(DefaultTitle, { isSrcToken: !inverted, textLeft: t.swapOne, textRight: t.isWorth, token: token, onTokenClick: inverted ? onDstSelect : onSrcSelect });
};
var StyledInvertprice = (0, styled_components_1.styled)("div")({
    cursor: "pointer",
    "&:hover": {
        opacity: 0.8,
    },
});
var StyledPercentContainer = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
});
var LimitPriceLabel = function () {
    var _a = (0, context_1.useTwapContext)(), t = _a.translations, isLimitPanel = _a.isLimitPanel;
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    return ((0, jsx_runtime_1.jsxs)(base_1.Label, { children: [(0, jsx_runtime_1.jsx)(base_1.Label.Text, { text: !isLimitPanel ? t.price : t.limitPrice }), (0, jsx_runtime_1.jsx)(base_1.Label.Info, { text: isMarketOrder ? t.marketPriceTooltip : isLimitPanel ? t.limitPriceTooltipLimitPanel : t.limitPriceTooltip })] }));
};
exports.LimitPanel.Input = Input;
exports.LimitPanel.TokenSelect = TokenSelect;
exports.LimitPanel.PercentSelector = PercentSelector;
exports.LimitPanel.Title = Title;
exports.LimitPanel.Switch = LimitSwitch_1.LimitSwitch;
exports.LimitPanel.InvertPrice = InvertPrice;
exports.LimitPanel.Label = LimitPriceLabel;
exports.LimitPanel.Main = Main;
var Container = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    ".MuiSkeleton-root": {
        left: 0,
        right: "unset",
    },
});
